import { IFieldControl } from "@core/services/interfaces/business/dealerships/IDealershipsService";

const fieldControl: IFieldControl = {
  RazaoSocial: {
    required: true,
    optional: false,
  },
  NomeFantasia: {
    required: true,
    optional: false,
  },
  CNPJ: {
    required: true,
    optional: false,
  },
  Email: {
    required: false,
    optional: true,
  },
  EmailFaturamento: {
    required: false,
    optional: false,
  },
  Telefone: {
    required: false,
    optional: false,
  },
  Site: {
    required: false,
    optional: false,
  },
  Codigo: {
    required: false,
    optional: true,
  },
  CodigoFaturamento: {
    required: false,
    optional: false,
  },
  Matriz: {
    required: false,
    optional: false,
  },
  GrupoEmpresaId: {
    required: false,
    optional: true,
  },
  CEP: {
    required: false,
    optional: false,
  },
  EstadoId: {
    required: true,
    optional: false,
  },
  MunicipioId: {
    required: true,
    optional: false,
  },
  Bairro: {
    required: false,
    optional: false,
  },
  Numero: {
    required: false,
    optional: false,
  },
  Complemento: {
    required: false,
    optional: false,
  },
  Logradouro: {
    required: false,
    optional: false,
  },
  Coordenadas: {
    required: false,
    optional: false,
  },
  Cadastrada: {
    required: true,
    optional: false,
  },
  Associada: {
    required: true,
    optional: false,
  },
  PendenciaFinanceira: {
    required: false,
    optional: false,
  },
  Status: {
    required: true,
    optional: false,
  },
  DataInauguracao: {
    required: false,
    optional: false,
  },
  DataNomeacao: {
    required: false,
    optional: false,
  },
  DataCancelamento: {
    required: false,
    optional: false,
  },
  InscricaoEstadual: {
    required: false,
    optional: false,
  },
  InscricaoMunicipal: {
    required: false,
    optional: false,
  },
  Montadora: {
    required: true,
    optional: false,
  },
  Observacoes: {
    required: false,
    optional: false,
  },
  Endereco: {
    required: false,
    optional: false,
  },
};

export default fieldControl;
